"use client";

import { c as _c } from "react/compiler-runtime";
import { type BackendProductResponse } from "@sprawdzonabron/shared";
import { forwardRef } from "react";
import { ProductCard } from "./ProductCard";
interface ProductItemProps {
  product: BackendProductResponse;
}
export const ProductItem = forwardRef<HTMLDivElement, ProductItemProps>((t0, ref) => {
  const $ = _c(5);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product) {
    t1 = <ProductCard product={product} />;
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ref || $[3] !== t1) {
    t2 = <div ref={ref}>{t1}</div>;
    $[2] = ref;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export const ProductItemSkeleton = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-between items-start gap-3 mb-3"><div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-3/4" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-between mb-4 text-xs"><div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-1/4" /><div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-1/4" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-wrap gap-1.5 mb-6 mt-auto"><div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/6" /><div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/6" /><div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/6" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col"><div className="h-6 bg-slate-200 dark:bg-slate-700 rounded w-1/2" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="group relative flex flex-col bg-white dark:bg-slate-850 rounded-xl border border-slate-200 dark:border-slate-800 transition-all duration-300 p-5 h-full animate-pulse">{t0}{t1}{t2}<div className="pt-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between mt-auto">{t3}<div className="flex items-center gap-2"><div className="h-8 w-8 bg-slate-200 dark:bg-slate-700 rounded-lg" /><div className="h-8 w-24 bg-slate-200 dark:bg-slate-700 rounded-lg" /></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};